import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { useFormContext } from 'react-hook-form';
import { resolvePath } from "../utils";

export default function FormAccordionSection({ title, children, id, bodyClassName = "" }) {
    const { formState } = useFormContext();
    const error = resolvePath(formState.errors, id);
    const [activeKey, setActiveKey] = useState();

    useEffect(() => {
        if (error) {
            setActiveKey("0");
        }
    }, [formState]);

    return (
        <Accordion onSelect={key => setActiveKey(key)} activeKey={activeKey}>
            <Accordion.Item eventKey="0">
                <Accordion.Header>{title}</Accordion.Header>
                <Accordion.Body className={bodyClassName}>
                    {children}
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
}